import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var filterSvg = function filterSvg(isDarkMode) {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19.909",
    height: "21.443",
    viewBox: "0 0 19.909 21.443",
    children: /*#__PURE__*/_jsx("path", {
      fill: isDarkMode ? "#fff" : "#000",
      id: "filter-141",
      d: "M.766,3.574H7.509a2.8,2.8,0,0,0,5.4,0h7.768a.766.766,0,1,0,0-1.531H12.907a2.8,2.8,0,0,0-5.4,0H.766a.766.766,0,0,0,0,1.531Zm9.442-2.042A1.276,1.276,0,1,1,8.932,2.808a1.276,1.276,0,0,1,1.276-1.276ZM20.675,9.189H17.926a2.8,2.8,0,0,0-5.225,0H.766a.766.766,0,1,0,0,1.531H12.557a2.805,2.805,0,0,0,5.517,0h2.6a.766.766,0,1,0,0-1.531Zm-5.362,2.3A1.276,1.276,0,1,1,16.59,10.21,1.276,1.276,0,0,1,15.313,11.486Zm5.362,4.85H9.339a2.8,2.8,0,0,0-5.4,0H.766a.766.766,0,0,0,0,1.531H3.941a2.8,2.8,0,0,0,5.4,0H20.675a.766.766,0,1,0,0-1.531ZM6.64,18.378A1.276,1.276,0,1,1,7.916,17.1,1.276,1.276,0,0,1,6.64,18.378Z",
      transform: "translate(19.909) rotate(90)"
    })
  });
};
export var loadMoreSvg = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "8",
  viewBox: "0 0 9 8",
  children: /*#__PURE__*/_jsxs("g", {
    id: "Group_11001",
    "data-name": "Group 11001",
    transform: "translate(-630 -1255)",
    children: [/*#__PURE__*/_jsx("rect", {
      id: "Rectangle_17098",
      "data-name": "Rectangle 17098",
      width: "1",
      height: "8",
      rx: "0.5",
      transform: "translate(630 1255)",
      fill: "#908f95"
    }), /*#__PURE__*/_jsx("rect", {
      id: "Rectangle_17099",
      "data-name": "Rectangle 17099",
      width: "1",
      height: "5",
      rx: "0.5",
      transform: "translate(634 1258)",
      fill: "#908f95"
    }), /*#__PURE__*/_jsx("rect", {
      id: "Rectangle_17100",
      "data-name": "Rectangle 17100",
      width: "1",
      height: "6",
      rx: "0.5",
      transform: "translate(638 1255)",
      fill: "#908f95"
    })]
  })
});
export var noDealsvg = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "85.09",
  height: "81",
  viewBox: "0 0 85.09 81",
  children: /*#__PURE__*/_jsx("g", {
    id: "shopping",
    transform: "translate(-29.76 -40.99)",
    children: /*#__PURE__*/_jsxs("g", {
      id: "Out_of_Stock",
      "data-name": "Out of Stock",
      transform: "translate(29.76 40.99)",
      children: [/*#__PURE__*/_jsx("path", {
        id: "Path_8398",
        "data-name": "Path 8398",
        d: "M200.691,61.787A17.785,17.785,0,1,1,182.9,44a17.785,17.785,0,0,1,17.787,17.787Z",
        transform: "translate(-139.443 -43.429)",
        fill: "#f5f5f5"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8399",
        "data-name": "Path 8399",
        d: "M202.756,68.52a13.136,13.136,0,1,0,13.136,13.135A13.136,13.136,0,0,0,202.756,68.52Zm0,22.558a9.367,9.367,0,0,1-4.993-1.434L210.748,76.66a9.42,9.42,0,0,1-7.99,14.417Zm0-18.85a9.361,9.361,0,0,1,5,1.438c0,.019-12.984,13-12.984,12.982a9.42,9.42,0,0,1,7.988-14.417Z",
        transform: "translate(-159.296 -63.298)",
        fill: "#e08326"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8400",
        "data-name": "Path 8400",
        d: "M206.013,177.07a17.814,17.814,0,0,1-11.142,9.612l-.99-1.239-1.409,1.766a17.789,17.789,0,0,1-18.76-10.139Z",
        transform: "translate(-146.404 -151.257)",
        fill: "url(#linear-gradient)"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8401",
        "data-name": "Path 8401",
        d: "M180.456,77.7a18.356,18.356,0,1,1,18.356-18.356A18.356,18.356,0,0,1,180.456,77.7Zm0-35.573a17.218,17.218,0,1,0,17.218,17.218A17.218,17.218,0,0,0,180.456,42.13Z",
        transform: "translate(-136.996 -40.99)",
        fill: "#5e6175"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8402",
        "data-name": "Path 8402",
        d: "M280.07,194.04H307.6v43.9H280.07Z",
        transform: "translate(-232.588 -165.008)",
        fill: "url(#linear-gradient-2)"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8403",
        "data-name": "Path 8403",
        d: "M80.79,194.04h37.8v43.9H80.79Z",
        transform: "translate(-71.11 -165.008)",
        fill: "url(#linear-gradient-3)"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8404",
        "data-name": "Path 8404",
        d: "M118.59,194.04v9.5l-4.162,6.066H80.79V203.54H111Z",
        transform: "translate(-71.11 -165.008)",
        fill: "url(#linear-gradient-4)"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8405",
        "data-name": "Path 8405",
        d: "M280.06,204.253V194.04l7.588,9.5h19.944v6.066H284.358Z",
        transform: "translate(-232.58 -165.008)",
        fill: "url(#linear-gradient-5)"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8406",
        "data-name": "Path 8406",
        d: "M305.738,236.042H277.07V191h28.668Zm-27.53-1.138H304.6V192.138H278.208Z",
        transform: "translate(-230.158 -162.544)",
        fill: "#5e6175"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8407",
        "data-name": "Path 8407",
        d: "M116.728,236.044H77.79V191h38.938Zm-37.8-1.138H115.59V192.138H78.928Z",
        transform: "translate(-68.679 -162.544)",
        fill: "#5e6175"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8408",
        "data-name": "Path 8408",
        d: "M304.4,374.83h9.987v5.158H304.4Z",
        transform: "translate(-252.303 -311.504)",
        fill: "#5e6175"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8409",
        "data-name": "Path 8409",
        d: "M74.708,203.54H36l7.588-9.5H82.3Z",
        transform: "translate(-34.816 -165.008)",
        fill: "#f5f5f5"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8410",
        "data-name": "Path 8410",
        d: "M287.648,203.54H315.68l-7.59-9.5H280.06Z",
        transform: "translate(-232.58 -165.008)",
        fill: "#f5f5f5"
      }), /*#__PURE__*/_jsxs("g", {
        id: "Group_13309",
        "data-name": "Group 13309",
        transform: "translate(0 18.107)",
        children: [/*#__PURE__*/_jsx("path", {
          id: "Path_8411",
          "data-name": "Path 8411",
          d: "M69.925,201.645H29.76L38.258,191H78.423Zm-37.8-1.138h37.25l6.681-8.369H38.806Z",
          transform: "translate(-29.76 -180.651)",
          fill: "#5e6175"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_8412",
          "data-name": "Path 8412",
          d: "M311.814,201.645H282.326L273.83,191h29.487Zm-28.939-1.138h26.574l-6.679-8.369H276.2Z",
          transform: "translate(-227.532 -180.651)",
          fill: "#5e6175"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_8413",
          "data-name": "Path 8413",
          d: "M85.781,141.263a2.411,2.411,0,1,0-.006,0Zm0-3.676a1.256,1.256,0,1,0,.006,0Z",
          transform: "translate(-73.204 -136.443)",
          fill: "#5e6175"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_8414",
          "data-name": "Path 8414",
          d: "M35.594,175.951a1.846,1.846,0,1,1,1.809-1.458A1.846,1.846,0,0,1,35.594,175.951Zm0-2.553a.7.7,0,1,0,.006,0Z",
          transform: "translate(-32.995 -165.466)",
          fill: "#5e6175"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_8415",
          "data-name": "Path 8415",
          d: "M0,0H1.138V3.644H0Z",
          transform: "translate(76.317 57.64) rotate(-45)",
          fill: "#5e6175"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_8416",
          "data-name": "Path 8416",
          d: "M444.35,419.37h3.644v1.138H444.35Z",
          transform: "translate(-365.706 -365.701)",
          fill: "#5e6175"
        }), /*#__PURE__*/_jsx("path", {
          id: "Path_8417",
          "data-name": "Path 8417",
          d: "M416.61,448.79h1.138v3.644H416.61Z",
          transform: "translate(-343.228 -389.541)",
          fill: "#5e6175"
        })]
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8418",
        "data-name": "Path 8418",
        d: "M377.089,91.438l-.717-.884.884-.717.717.884Zm-1.91-2.358-.717-.886.884-.715.717.884Zm-1.91-2.352-.717-.884.884-.717.717.886Zm-1.886-2.276a3.169,3.169,0,0,0-.789-.55l.5-1.021a4.323,4.323,0,0,1,1.07.747Zm-2.373-.882h-1.138V82.431h1.138Zm-3.035,0h-1.138V82.431h1.138Zm-3.092-.023a4.344,4.344,0,0,1-1.263-.33l.45-1.045a3.214,3.214,0,0,0,.931.243Zm-2.971-1.654a4.306,4.306,0,0,1-.637-1.138l1.066-.4a3.162,3.162,0,0,0,.47.84Zm.243-3.187-1.138-.036c.011-.364.015-.74.01-1.113l1.138-.013c.006.377,0,.768-.009,1.148Zm-1.214-3.016c-.032-.368-.074-.74-.121-1.106l1.127-.15c.051.379.095.772.129,1.155Zm-.436-2.933c-.078-.362-.163-.727-.256-1.081l1.1-.288c.1.379.19.759.268,1.138Zm-.791-2.845c-.121-.351-.25-.7-.379-1.043l1.038-.429c.142.357.279.725.4,1.091Zm-1.138-2.735c-.161-.33-.334-.662-.512-.986l.981-.558c.19.34.368.689.539,1.034ZM355.11,64.6c-.2-.305-.412-.615-.63-.918l.926-.664c.226.317.448.639.656.96Z",
        transform: "translate(-292.883 -58.841)",
        fill: "#a9afc4"
      }), /*#__PURE__*/_jsx("path", {
        id: "Path_8419",
        "data-name": "Path 8419",
        d: "M45.353,437.471a2.134,2.134,0,1,1,1.872-1.1A2.136,2.136,0,0,1,45.353,437.471Zm0-3.134a1,1,0,1,0,.779.376,1,1,0,0,0-.779-.376Z",
        transform: "translate(-40.664 -358.8)",
        fill: "#5e6175"
      })]
    })
  })
});